import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 

  faReceipt, 
  faWallet, 
  faClipboardList, 
  faUtensils, 

  faUser,

  faChartLine,
  faClock,

  faFire,
  faChevronLeft,
  faChevronRight as faChevronRightIcon
} from '@fortawesome/free-solid-svg-icons';
import { postData } from '../../../Services/Fetchnodeservices';
import { useNavigate } from 'react-router-dom';

// Import all banner images

import banner2 from '../../../assets/Untitled design - 2026-07-21T161133.846.png';
import banner3 from '../../../assets/Untitled design - 2026-07-21T154132.788.png';
import banner4 from '../../../assets/Untitled design - 2026-07-21T154857.551.png';
import banner5 from '../../../assets/Untitled design - 2026-07-21T154939.256.png';
import banner6 from '../../../assets/Untitled design - 2026-07-21T155019.449.png';
import banner7 from '../../../assets/Untitled design - 2026-07-21T155108.555.png';


// ================= ZAPTODOOR ORANGE THEME CONFIG =================
const ZaptoDoorTheme = {
  dark: {
    name: "Dark Theme",
    bg: "#0f172a",
    cardBg: "rgba(30, 41, 59, 0.8)",
    cardBorder: "rgba(249, 115, 22, 0.2)",
    textPrimary: "#f8fafc",
    textSecondary: "#94a3b8",
    textMuted: "#64748b",
    headerGradient: "linear-gradient(135deg, #ea580c 0%, #f97316 50%, #fb923c 100%)",
    notifGradient: "linear-gradient(90deg, #f97316, #fb923c)",
    statusGradient: "linear-gradient(135deg, #059669, #10b981)",
    statusIconBg: "rgba(16, 185, 129, 0.15)",
    statusIcon: "#ffffff",
    statusDot: "#6ee7b7",
    statusBorder: "#059669",
    statusText: "#d1fae5",
    openBtnBg: "#10b981",
    openBtnHover: "#059669",
    navBg: "rgba(15, 23, 42, 0.95)",
    navBorder: "rgba(249, 115, 22, 0.2)",
    navActive: "#f97316",
    navInactive: "#94a3b8",
    iconBgOrange: "rgba(249, 115, 22, 0.15)",
    iconBgGreen: "rgba(16, 185, 129, 0.15)",
    iconBgRed: "rgba(220, 38, 38, 0.15)",
    iconBgYellow: "rgba(245, 158, 11, 0.15)",
    iconTextOrange: "#f97316",
    iconTextGreen: "#16a34a",
    iconTextRed: "#dc2626",
    iconTextYellow: "#f59e0b",
    settingsBtnBg: "rgba(255,255,255,0.08)",
    quickActionGradient: "linear-gradient(90deg, #f97316, #f59e0b)",
    shadow: "0 25px 50px -12px rgba(0, 0, 0, 0.4)",
    shadowSm: "0 10px 30px -10px rgba(0, 0, 0, 0.3)",
    blurBg: "rgba(255,255,255,0.03)",
  },
  light: {
    name: "Light Theme",
    bg: "#fff7ed",
    cardBg: "rgba(255, 255, 255, 0.85)",
    cardBorder: "rgba(249, 115, 22, 0.2)",
    textPrimary: "#0f172a",
    textSecondary: "#64748b",
    textMuted: "#94a3b8",
    headerGradient: "linear-gradient(135deg, #f97316 0%, #fb923c 50%, #fdba74 100%)",
    notifGradient: "linear-gradient(90deg, #f97316, #fb923c)",
    statusGradient: "linear-gradient(135deg, #059669, #10b981)",
    statusIconBg: "rgba(16, 185, 129, 0.15)",
    statusIcon: "#ffffff",
    statusDot: "#6ee7b7",
    statusBorder: "#059669",
    statusText: "#d1fae5",
    openBtnBg: "#10b981",
    openBtnHover: "#059669",
    navBg: "rgba(255, 247, 237, 0.95)",
    navBorder: "rgba(249, 115, 22, 0.2)",
    navActive: "#f97316",
    navInactive: "#64748b",
    iconBgOrange: "rgba(249, 115, 22, 0.1)",
    iconBgGreen: "rgba(16, 185, 129, 0.1)",
    iconBgRed: "rgba(220, 38, 38, 0.1)",
    iconBgYellow: "rgba(245, 158, 11, 0.1)",
    iconTextOrange: "#f97316",
    iconTextGreen: "#16a34a",
    iconTextRed: "#dc2626",
    iconTextYellow: "#f59e0b",
    settingsBtnBg: "rgba(255,255,255,0.5)",
    quickActionGradient: "linear-gradient(90deg, #f97316, #f59e0b)",
    shadow: "0 25px 50px -12px rgba(249, 115, 22, 0.15)",
    shadowSm: "0 10px 30px -10px rgba(249, 115, 22, 0.08)",
    blurBg: "rgba(255,255,255,0.5)",
  },
};

// ================= BANNER CAROUSEL COMPONENT =================
const BannerCarousel = ({ theme }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);

  // Banner images array - Fully Dynamic
  const banners = [
   
    { id: 2, image: banner2, alt: 'Zaptodoor Banner 2' },
    { id: 3, image: banner3, alt: 'Zaptodoor Banner 3' },
    { id: 4, image: banner4, alt: 'Zaptodoor Banner 4' },
    { id: 5, image: banner5, alt: 'Zaptodoor Banner 5' },
    { id: 6, image: banner6, alt: 'Zaptodoor Banner 6' },
    { id: 7, image: banner7, alt: 'Zaptodoor Banner 7' },
  
  ];

  // Auto-scroll functionality
  useEffect(() => {
    if (!isPaused) {
      timerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
      }, 4000); // Change slide every 4 seconds
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isPaused, banners.length]);

  // Go to specific slide
  const goToSlide = (index) => {
    setCurrentIndex(index);
    // Reset timer when manually navigating
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
      }, 4000);
    }
  };

  // Next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  // Previous slide
  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  return (
    <div
      style={{
        padding: "0 0px",
        marginBottom: "24px",
        position: "relative",
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        style={{
          borderRadius: "24px",
          padding: "0",
          minHeight: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 12px 30px rgba(249, 115, 22, 0.25)",
          position: "relative",
          overflow: "hidden",
          background: theme.headerGradient,
        }}
      >
        {/* Slides Container */}
        <div
          style={{
            display: "flex",
            transition: "transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)",
            transform: `translateX(-${currentIndex * 100}%)`,
            width: "100%",
          }}
        >
          {banners.map((banner) => (
            <div
              key={banner.id}
              style={{
                minWidth: "100%",
                height: "200px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <img
                src={banner.image}
                alt={banner.alt}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                }}
              />
              {/* Gradient overlay for better text visibility */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "50%",
                  background: "linear-gradient(transparent, rgba(0,0,0,0.4))",
                }}
              />
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            transition: "all 0.2s ease",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = "#ffffff";
            e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.9)";
            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#ea580c", fontSize: "16px" }} />
        </button>

        <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            transition: "all 0.2s ease",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = "#ffffff";
            e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.9)";
            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
          }}
        >
          <FontAwesomeIcon icon={faChevronRightIcon} style={{ color: "#ea580c", fontSize: "16px" }} />
        </button>

        {/* Dots Indicator */}
        <div
          style={{
            position: "absolute",
            bottom: "12px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
            display: "flex",
            gap: "8px",
          }}
        >
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                width: currentIndex === index ? "24px" : "8px",
                height: "8px",
                borderRadius: "4px",
                border: "none",
                background: currentIndex === index 
                  ? "#ffffff" 
                  : "rgba(255,255,255,0.5)",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// ================= MAIN COMPONENT =================
export default function DashboardHome({ 
  isDark = true,
  onStatPress = () => {}
}) {
  const navigate = useNavigate();
  const theme = isDark ? ZaptoDoorTheme.dark : ZaptoDoorTheme.light;
  
  // State for dashboard data
  const [dashboardData, setDashboardData] = useState({
    todayOrders: 0,
    todayEarnings: 0,
    pendingCount: 0,
    preparingCount: 0,
    monthlyOrders: 0,
    monthlyEarnings: 0,
    totalCustomers: 0,
    avgOrderValue: 0,
    allOrders: [],
    statsLoading: true
  });

  // Get user data from localStorage
  const getUserData = () => {
    try {
      const userDataStr = localStorage.getItem('userData');
      if (userDataStr) {
        return JSON.parse(userDataStr);
      }
      return null;
    } catch (e) {
      console.log('Error parsing userData:', e);
      return null;
    }
  };

  // Handle card click - navigate to orders with filter
  const handleCardClick = (filterType, filterValue) => {
    console.log(`🔍 Navigating to Orders with filter: ${filterType} = ${filterValue}`);
    
    sessionStorage.setItem('ordersFilter', JSON.stringify({
      type: filterType,
      value: filterValue,
      label: getFilterLabel(filterType, filterValue)
    }));
    
    navigate('/dashboard/OrdersList');
  };

  // Get filter label for display
  const getFilterLabel = (type, value) => {
    const labels = {
      'todayOrders': 'Today\'s Orders',
      'pending': 'Pending Orders',
      'preparing': 'Preparing Orders',
      'monthly': 'Monthly Orders',
      'customers': 'Total Customers'
    };
    return labels[type] || value;
  };

  // Fetch dashboard data from API
  const fetchDashboardData = async () => {
    const userData = getUserData();
    const restaurantId = userData?.id || userData?.restaurantId || localStorage.getItem('restaurantId');
    
    if (!restaurantId) {
      console.log('No restaurant ID found');
      setDashboardData(prev => ({ ...prev, statsLoading: false }));
      return;
    }

    try {
      setDashboardData(prev => ({ ...prev, statsLoading: true }));
      
      const result = await postData('vanderorders/orders/list', { 
        designation_id: restaurantId 
      });

      console.log('📊 Dashboard API Response:', result);

      if (!result.success || !result.orders) {
        setDashboardData(prev => ({ ...prev, statsLoading: false }));
        return;
      }

      const allOrders = result.orders.map(order => ({
        ...order,
        parsedItems: typeof order.items === 'string' ? JSON.parse(order.items) : (order.items || []),
      }));

      const today = new Date().toISOString().split('T')[0];
      const currentMonth = new Date().toISOString().slice(0, 7);

      // Today's Orders
      const todayOrders = allOrders.filter(o => {
        const orderDate = new Date(o.created_at).toISOString().split('T')[0];
        return orderDate === today;
      });

      // Today's Earnings (excluding cancelled)
      const todayEarnings = todayOrders
        .filter(o =>
          o.order_status_user !== 'cancelled' &&
          o.order_status_user !== 'user_cancelled' &&
          o.order_status_restro !== 'cancelled'
        )
        .reduce((sum, o) => sum + Number(o.business_amount || 0), 0);

      // Pending Orders
      const pendingOrders = allOrders.filter(o => o.order_status_restro === 'pending');
      const pendingCount = pendingOrders.length;

      // Preparing Orders
      const preparingOrders = allOrders.filter(o => o.order_status_restro === 'preparing');
      const preparingCount = preparingOrders.length;

      // Monthly Orders
      const monthlyOrders = allOrders.filter(o => {
        const orderMonth = new Date(o.created_at).toISOString().slice(0, 7);
        return orderMonth === currentMonth;
      });

      // Monthly Earnings
      const monthlyEarnings = monthlyOrders
        .filter(o =>
          o.order_status_user !== 'cancelled' &&
          o.order_status_user !== 'user_cancelled' &&
          o.order_status_restro !== 'cancelled'
        )
        .reduce((sum, o) => sum + Number(o.business_amount || 0), 0);

      // Total Customers (unique)
      const uniqueCustomers = new Set(allOrders.map(o => o.receiver_phone || o.receiver_id));
      
      // Average Order Value
      const completedOrders = allOrders.filter(o =>
        o.order_status_user === 'delivered' || 
        o.order_status_restro === 'completed'
      );
      const avgOrderValue = completedOrders.length > 0 
        ? completedOrders.reduce((sum, o) => sum + Number(o.business_amount || 0), 0) / completedOrders.length 
        : 0;

      setDashboardData({
        todayOrders: todayOrders.length,
        todayEarnings: todayEarnings,
        pendingCount: pendingCount,
        preparingCount: preparingCount,
        monthlyOrders: monthlyOrders.length,
        monthlyEarnings: monthlyEarnings,
        totalCustomers: uniqueCustomers.size,
        avgOrderValue: avgOrderValue,
        allOrders: allOrders,
        pendingOrders: pendingOrders,
        preparingOrders: preparingOrders,
        todayOrdersList: todayOrders,
        monthlyOrdersList: monthlyOrders,
        statsLoading: false
      });

    } catch (e) {
      console.log('❌ Dashboard Data Fetch Error:', e);
      setDashboardData(prev => ({ ...prev, statsLoading: false }));
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // Format currency
  const formatCurrency = (amount) => {
    return `₹${Number(amount).toLocaleString('en-IN', { 
      maximumFractionDigits: 0 
    })}`;
  };

  return (
    <div
      style={{
        backgroundColor: theme.bg,
        color: theme.textPrimary,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        overflowX: 'hidden',
        paddingBottom: '20px',
      }}
    >
      {/* ===== ZAPTODOOR AUTO-SCROLL BANNER CAROUSEL ===== */}
      <BannerCarousel theme={theme} />

      {/* Stats Grid - 4 Cards with Navigation */}
      <div
        style={{
          padding: '0px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '16px',
          marginBottom: '24px',
        }}
      >
        <StatCard
          icon={faReceipt}
          iconBg={theme.iconBgOrange}
          iconColor={theme.iconTextOrange}
          value={dashboardData.statsLoading ? '...' : dashboardData.todayOrders}
          label="Today's Orders"
          theme={theme}
          filterType="todayOrders"
          filterValue={dashboardData.todayOrdersList || []}
          onNavigate={handleCardClick}
        />
        <StatCard
          icon={faWallet}
          iconBg={theme.iconBgGreen}
          iconColor={theme.iconTextGreen}
          value={dashboardData.statsLoading ? '...' : formatCurrency(dashboardData.todayEarnings)}
          label="Today's Earnings"
          theme={theme}
          filterType="earnings"
          filterValue={dashboardData.todayOrdersList || []}
          onNavigate={handleCardClick}
        />
        <StatCard
          icon={faClipboardList}
          iconBg={theme.iconBgRed}
          iconColor={theme.iconTextRed}
          value={dashboardData.statsLoading ? '...' : dashboardData.pendingCount}
          label="Pending Orders"
          theme={theme}
          filterType="pending"
          filterValue={dashboardData.pendingOrders || []}
          onNavigate={handleCardClick}
        />
        <StatCard
          icon={faUtensils}
          iconBg={theme.iconBgYellow}
          iconColor={theme.iconTextYellow}
          value={dashboardData.statsLoading ? '...' : dashboardData.preparingCount}
          label="Preparing"
          theme={theme}
          filterType="preparing"
          filterValue={dashboardData.preparingOrders || []}
          onNavigate={handleCardClick}
        />
      </div>

      {/* Extended Stats - 4 More Cards with Navigation (ORANGE THEME) */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '16px',
          marginBottom: '24px',
        }}
      >
        <ExtendedStatCard
          icon={faChartLine}
          iconBg="rgba(249, 115, 22, 0.15)"
          iconColor="#f97316"
          value={dashboardData.statsLoading ? '...' : dashboardData.monthlyOrders}
          label="Monthly Orders"
          theme={theme}
          filterType="monthly"
          filterValue={dashboardData.monthlyOrdersList || []}
          onNavigate={handleCardClick}
        />
        <ExtendedStatCard
          icon={faFire}
          iconBg="rgba(251, 146, 60, 0.15)"
          iconColor="#fb923c"
          value={dashboardData.statsLoading ? '...' : formatCurrency(dashboardData.monthlyEarnings)}
          label="Monthly Earnings"
          theme={theme}
          filterType="earnings"
          filterValue={dashboardData.monthlyOrdersList || []}
          onNavigate={handleCardClick}
        />
        <ExtendedStatCard
          icon={faUser}
          iconBg="rgba(253, 186, 116, 0.15)"
          iconColor="#fdba74"
          value={dashboardData.statsLoading ? '...' : dashboardData.totalCustomers}
          label="Total Customers"
          theme={theme}
          filterType="customers"
          filterValue={dashboardData.totalCustomers || 0}
          onNavigate={handleCardClick}
        />
        <ExtendedStatCard
          icon={faClock}
          iconBg="rgba(234, 88, 12, 0.15)"
          iconColor="#ea580c"
          value={dashboardData.statsLoading ? '...' : formatCurrency(dashboardData.avgOrderValue)}
          label="Avg Order Value"
          theme={theme}
          filterType="avgValue"
          filterValue={dashboardData.avgOrderValue || 0}
          onNavigate={handleCardClick}
        />
      </div>
    </div>
  );
}

// ================= STAT CARD COMPONENT =================
function StatCard({ icon, iconBg, iconColor, value, label, theme, filterType, filterValue, onNavigate }) {
  return (
    <div
      style={{
        background: theme.cardBg,
        backdropFilter: 'blur(12px)',
        border: `1px solid ${theme.cardBorder}`,
        borderRadius: '20px',
        padding: '20px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
      }}
      onClick={() => {
        if (onNavigate && filterType) {
          onNavigate(filterType, filterValue);
        }
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
        e.currentTarget.style.boxShadow = theme.shadow;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div
        style={{
          background: iconBg,
          width: '48px',
          height: '48px',
          borderRadius: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
          backdropFilter: 'blur(4px)',
        }}
      >
        <FontAwesomeIcon icon={icon} style={{ width: '22px', height: '22px', color: iconColor }} />
      </div>
      <h3
        style={{
          color: theme.textPrimary,
          fontSize: '24px',
          fontWeight: '800',
          margin: 0,
          letterSpacing: '-0.5px',
        }}
      >
        {value}
      </h3>
      <p
        style={{
          color: theme.textSecondary,
          fontSize: '13px',
          margin: '4px 0 0',
        }}
      >
        {label}
      </p>
    </div>
  );
}

// ================= EXTENDED STAT CARD =================
function ExtendedStatCard({ icon, iconBg, iconColor, value, label, theme, filterType, filterValue, onNavigate }) {
  return (
    <div
      style={{
        background: theme.cardBg,
        backdropFilter: 'blur(12px)',
        border: `1px solid ${theme.cardBorder}`,
        borderRadius: '16px',
        padding: '16px 18px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        cursor: 'pointer',
      }}
      onClick={() => {
        if (onNavigate && filterType) {
          onNavigate(filterType, filterValue);
        }
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = theme.shadowSm;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div
        style={{
          background: iconBg,
          width: '44px',
          height: '44px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <FontAwesomeIcon icon={icon} style={{ width: '20px', height: '20px', color: iconColor }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h4
          style={{
            color: theme.textPrimary,
            fontSize: '20px',
            fontWeight: '800',
            margin: 0,
            letterSpacing: '-0.3px',
          }}
        >
          {value}
        </h4>
        <p
          style={{
            color: theme.textSecondary,
            fontSize: '12px',
            margin: '2px 0 0',
          }}
        >
          {label}
        </p>
      </div>
    </div>
  );
}